@if (loaded) {
    <div class="login-body">
        <p-toast key="top" position="top-center">
        </p-toast>
        <div class="login-panel">
            <div class="grid">
                <div class="login-header">
                <img class="login-logo" [src]="app.getLogoLoginPngUrl()" />
                <h1>Erste Anmeldung</h1>
                <h2>{{app.appName}}</h2>
                </div>
                @if (app.mainConfig.authRules.useRecoveryQuestions) {
                    <span style="text-align: left;margin-bottom: 20px">
                        Sie melden sich gerade das erste Mal an. Bitte vergeben Sie ein neues Passwort und beantworten Sie mindestens {{app.mainConfig.authRules.minRecoveryQuestions}} der untenstehenden Sicherheitsfragen.
                    </span>
                }
                @else {
                    <span style="text-align: left;margin-bottom: 20px">
                        Sie melden sich gerade das erste Mal an. Bitte vergeben Sie ein neues Passwort.
                    </span>
                }
                <span style="text-align: left;margin-bottom: 20px">{{pwText}}</span>
                <sm-form class="width100p" [form]="form">
                </sm-form>
                @if (running) {
                    <div>Einrichtung läuft ...</div>
                    <p-progressSpinner></p-progressSpinner>
                }
            </div>
        </div>
    </div>
}